import Payment from "./Payment";
import Delivery from "./Delivery";
import Gift from "./Gift";

export default { Payment, Delivery, Gift };



// WEBPACK FOOTER //
// ./src/containers/About/index.js